var exports = {
  "PT": "Markup.module__markup___cV96M0",
  "z3": "Markup.module__bio___cV96M0",
  "Z_": "Markup.module__mutedSpoilerContext___cV96M0",
  "nf": "Markup.module__link___cV96M0",
  "mG": "Markup.module__inline___cV96M0",
  "tZ": "Markup.module__inlineFormat___cV96M0",
  "Hy": "Markup.module__codeContainer___cV96M0",
  "h": "Markup.module__blockquoteContainer___cV96M0",
  "xE": "Markup.module__alert___cV96M0",
  "CZ": "Markup.module__tableContainer___cV96M0",
  "js": "Markup.module__latexCodeBlock___cV96M0",
  "lB": "Markup.module__codeActions___cV96M0",
  "vo": "Markup.module__codeActionsVisible___cV96M0",
  "r": "Markup.module__blockquoteDivider___cV96M0",
  "rs": "Markup.module__blockquoteContent___cV96M0",
  "em": "Markup.module__blockquoteEmptyContent___cV96M0",
  "tp": "Markup.module__table___cV96M0",
  "qd": "Markup.module__tableHeader___cV96M0",
  "xR": "Markup.module__tableCell___cV96M0",
  "Vl": "Markup.module__alignLeft___cV96M0",
  "Hu": "Markup.module__alignCenter___cV96M0",
  "Wk": "Markup.module__alignRight___cV96M0",
  "Qd": "Markup.module__alertIcon___cV96M0",
  "Ro": "Markup.module__alertTitle___cV96M0",
  "S9": "Markup.module__alertContent___cV96M0",
  "FU": "Markup.module__alertNote___cV96M0",
  "ap": "Markup.module__alertTip___cV96M0",
  "nL": "Markup.module__alertImportant___cV96M0",
  "vc": "Markup.module__alertWarning___cV96M0",
  "SN": "Markup.module__alertCaution___cV96M0",
  "lE": "Markup.module__mention___cV96M0",
  "bG": "Markup.module__interactive___cV96M0",
  "vE": "Markup.module__timestamp___cV96M0",
  "CU": "Markup.module__spoilerWrapper___cV96M0",
  "N5": "Markup.module__blockSpoilerWrapper___cV96M0",
  "p6": "Markup.module__spoiler___cV96M0",
  "mC": "Markup.module__blockSpoiler___cV96M0",
  "ur": "Markup.module__spoilerContent___cV96M0",
  "yI": "Markup.module__latexContent___cV96M0",
  "Y4": "Markup.module__hljs___cV96M0",
  "HQ": "Markup.module__ansiCode___cV96M0",
  "bi": "Markup.module__ansi-code-blink___cV96M0",
  "So": "Markup.module__error___cV96M0",
};

module.exports = exports;
